import React, { FC, useState } from 'react';

export interface IEventImage {
  brandingImage: any;
}

const EventImage: FC<IEventImage> = ({ brandingImage }) => {
  const [isImageLoaded, setIsImageLoaded] = useState<boolean>(true);
  const handleOnLoad = () => setIsImageLoaded(true);
  const handleOnError = () => setIsImageLoaded(false);
  return brandingImage && isImageLoaded ? (
    <div className="event-image-box">
      <img
        className="event-image"
        src={brandingImage}
        alt="js conference"
        onLoad={handleOnLoad}
        onError={handleOnError}
      />
    </div>
  ) : null;
};

export default EventImage;
